export default class payer_data {
  constructor(customerNumber, companyCode) {
    this.customer_number = customerNumber;
    this.company_code = companyCode;
    this.action = '';
  }
}
